/* build 2026-09-13T08:19 ET -- mobile timeline animation */
/* lr-about.js -- About page (TASK-1003), ported from mockups/about-page/mockup5.html.
   Two behaviours: per-element reveal-on-scroll, and the pinned timeline progress.
   iOS note (Translation 11): the timeline uses a scroll listener driving transform/width, not a
   CSS @keyframes animation, and the pin is position:sticky. main.css:19 sets
   body{overflow-x:hidden}; that was probed against a sticky pin replicating the theme's
   constraints and the pin holds. Any future ancestor with overflow:hidden WILL break it.
   Guarded so the file is inert on pages without the section. */
(function(){
  if(!document.querySelector('.lr-about')) return;
  /* Three sections each include this file, so without a latch the IIFE ran three times and
     attached three scroll listeners and three observer sets. */
  if (window.__lrAboutInit) return;
  window.__lrAboutInit = true;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobile = window.matchMedia('(max-width: 860px)').matches;

  /* --- Ethos review: pinned 3D slab (Damon, 2026-09-11) ---
     The section is 210vh with a sticky inner wrapper, so the review HOLDS in the viewport for
     about a screen and a half of scrolling. That dwell is the point: it gives the reader time to
     read the review instead of it sliding past.
     The card ARRIVES SQUARE (0deg) -- an entry tilt read as "pre-tilted" -- and the scroll turns
     it, so you see the slab's edge come round. One continuous sweep, no snap-back and no
     travelling highlight. Paired with the ::before back face in the CSS, which is what actually
     makes an edge visible under rotation.
     rAF-throttled scroll handler, not CSS @keyframes: iOS Safari stalls keyframes under URL-bar
     resize jitter (Translation 11). Inert under prefers-reduced-motion. */
  (function(){
    if (reduce) {
      document.querySelectorAll('.lr-about .lr-star').forEach(function(s){ s.classList.add('on'); });
      return;
    }
    var section = document.getElementById('lr-ethos');
    var card = document.querySelector('.lr-about .lr-rvcard');
    var starGroups = [].slice.call(document.querySelectorAll('.lr-about .lr-stars'));
    if (!starGroups.length && !card) return;
    var ticking = false;

    function fill(group, p) {
      if (!group) return;
      var stars = group.querySelectorAll('.lr-star');
      var lit = Math.max(0, Math.min(5, Math.round(p * 5)));
      for (var i = 0; i < lit && i < stars.length; i++) stars[i].classList.add('on');
    }

    // Ease the rotation in so the first few pixels of scroll do not snap the card off square.
    function easeInOut(t){ return t < 0.5 ? 2*t*t : 1 - Math.pow(-2*t + 2, 2) / 2; }

    function frame() {
      ticking = false;
      var vh = window.innerHeight;

      if (section && card && window.matchMedia('(min-width: 861px)').matches) {
        var b = section.getBoundingClientRect();
        var travel = b.height - vh;
        if (travel > 0) {
          var p = Math.max(0, Math.min(1, -b.top / travel));
          // Square on arrival, then one continuous turn to -11deg by the time it leaves.
          var turn = easeInOut(p);
          card.style.setProperty('--rv-ry', (turn * -11).toFixed(2) + 'deg');
          card.style.setProperty('--rv-rx', (turn * 2.4).toFixed(2) + 'deg');
          fill(card.parentElement.querySelector('.lr-stars'), p / 0.22);
        }
      }

      starGroups.forEach(function(g){
        var gb = g.getBoundingClientRect();
        if (gb.top > vh) return;
        fill(g, (vh - gb.top) / (vh * 0.42));
      });
    }

    function onScroll(){ if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    frame();
  })();

    if(!reduce){
      var rio = new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('lr-in');rio.unobserve(e.target);}});},{threshold:.12});
      document.querySelectorAll('.lr-rightsys .lr-grid, .lr-passion .lr-grid, .lr-testi .lr-in, .newsletter .lr-wide, .lr-cats .lr-wide').forEach(function(t){
        if(t.getBoundingClientRect().top > window.innerHeight*0.88){ t.classList.add('lr-reveal'); rio.observe(t); }
      });
      // Observe EACH card, not the container: the container is ~2000px tall, so a
      // container trigger fires every card at once and the lower ones have finished
      // animating before you scroll to them.
      var cardEls = document.querySelectorAll('.lr-cards .lr-card');
      if(cardEls.length){
        var cio = new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('lr-in');cio.unobserve(e.target);}});},{threshold:.18});
        cardEls.forEach(function(c){
          // Already on screen at load? Show it immediately; don't animate what the
          // visitor is already looking at.
          if(c.getBoundingClientRect().top < window.innerHeight*0.9){ c.classList.add('lr-in'); }
          else { cio.observe(c); }
        });
      }
    } else {
      document.querySelectorAll('.lr-cards .lr-card').forEach(function(c){ c.classList.add('lr-in'); });
    }
    var sec = document.getElementById('timeline');
    var steps = Array.prototype.slice.call(document.querySelectorAll('#steps .lr-step'));
    var fill = document.getElementById('tlfill');
    /* Reduced motion still gets the finished state instantly. MOBILE NO LONGER DOES:
       it used to short-circuit here alongside `reduce`, so every stop arrived pre-filled and the
       timeline had no animation on a phone at all (Damon, 2026-09-13). The pin is desktop-only,
       so on mobile the progress is driven by how far the (static) section has travelled UP through
       the viewport instead of by a pinned scroll range. */
    if(reduce || !sec){ steps.forEach(function(s){s.classList.add('active');}); if(fill) fill.style.width='100%'; return; }
    var n = steps.length;
    function onScroll(){
      var rect = sec.getBoundingClientRect();
      var vh = window.innerHeight;
      var pinned = sec.offsetHeight - vh > vh * 0.25;   // desktop: the section is 230vh and pins
      var p;
      if (pinned) {
        p = Math.min(1, Math.max(0, (-rect.top) / (sec.offsetHeight - vh)));
      } else {
        // Static/stacked: 0 when the top edge reaches the bottom of the screen, 1 once the
        // bottom edge has risen past ~30% of the way up it.
        var travel = rect.height + vh * 0.7;
        p = Math.min(1, Math.max(0, (vh - rect.top) / travel));
      }
      var idx = Math.min(n-1, Math.floor(p * n * 0.999));
      if (fill) fill.style.width = (idx/(n-1))*100 + '%';
      steps.forEach(function(s,i){ s.classList.toggle('active', i<=idx); s.classList.toggle('current', i===idx); });
    }
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll);
    onScroll();
  


})();
